import { render } from "./OnlineOrderComponent.vue?vue&type=template&id=659d877e"
import script from "./OnlineOrderComponent.vue?vue&type=script&lang=js"
export * from "./OnlineOrderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/onlineOrders/OnlineOrderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "659d877e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('659d877e', __exports__)) {
    api.reload('659d877e', __exports__)
  }
  
  module.hot.accept("./OnlineOrderComponent.vue?vue&type=template&id=659d877e", () => {
    api.rerender('659d877e', render)
  })

}


export default __exports__